import { render, staticRenderFns } from "./Alerte.vue?vue&type=template&id=b3a2e1ca"
import script from "./Alerte.vue?vue&type=script&lang=js"
export * from "./Alerte.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports